import Interaction from "./Interaction";
import { InteractionType } from "./Interaction";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import SetVariableNodePreview from "../../features/sequence/node_previews/SetVariableNodePreview";

export interface ISetVariable extends Interaction {
  variable: string; // Variable ID to set
  data: string | number | boolean; // Value to assign
}

export const setVariableInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): ISetVariable => {
    return {
      id: GetNewGuid(),
      name: "Set Variable",
      type: InteractionType.SetVariable,
      variable: "",
      data: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): ISetVariable => {
    return interaction as ISetVariable;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): ISetVariable => {
    const original = interaction as ISetVariable;
    return {
      id: GetNewGuid(),
      name: "Set Variable",
      type: InteractionType.SetVariable,
      variable: original.variable,
      data: original.data,
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    const warnings: string[] = [];
    return warnings;
  };

  const filterType = "SetVariable";

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    return getMatchingResults(
      [interaction.name],
      takeName,
      interaction,
      filterType
    );
  };

  const validateError = (interaction: Interaction): string[] => {
    const casted = interaction as ISetVariable;
    const errors: string[] = [];

    if (!casted.variable) {
      errors.push("Please select a variable to set");
    }

    return errors;
  };

  return {
    View: <div>Set Variable Node</div>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <SetVariableNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    Create: create,
    FilterType: filterType,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateError,
  };
};
